/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchApi } from "../../_config/api";
import {Collapse, Input, notification} from "antd";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


import {
    Card,
    TableContent, PaginationSection,
} from "../../library";
import { activityColumns } from "./columns";
import "./styles.less";
import {
    getUserDetails,
    ENTERPRISEDEVELOPERROLE,
    DEVELOPERROLE, getPATTokenDetails,
} from "../../deps";
import {
    DeveloperCard,
    EndpointCard3,
    ExampleCard,
    ProjectCard,
    ReleaseCard,
    TutorialCard
} from "../../library/card";
import { AccountInfoInfo } from "./accountInfo";
import {CopyOutlined} from "@ant-design/icons";
import {Menus} from "../../assets";



export const Dashboard = ({ showLoader,isLoading }) => {
    let noOfApiRan = 0;
    const navigate = useNavigate();
    const [cardData, setCardData] = useState({});
    const [activityList, setActivityList] = useState(null);
    const { userRole = DEVELOPERROLE, subscriptionId } = getUserDetails().profile || {};
    const { Panel } = Collapse;
    const [projectId, setProjectId] = useState("");
    const [projectDetails, setProjectDetails] = useState({});
    const [data, setData] = useState([]);
    const [projectcarddata, setProjectcardData] = useState([]);
    const [endPointsNav, setEndPointsNav] = useState(true)
    const [teamList, setTeamList] = useState([]);
    const userData = getUserDetails();
    const pattoken = getPATTokenDetails();

    useEffect(() => {
        noOfApiRan = 0;
        getCardData();
        getActivityList();
        getEndpointsList();
        getProjectListforcard();
    }, []);

    useEffect(() => {
        if (userData.profile.userRole === ENTERPRISEDEVELOPERROLE) {
            getTeamsList();
        }
    }, []);

    const [pageSetting, setSetting] = React.useState({
        page: 1,
        itemsPerPage: 10,
        searchText: "",
        filterValue: "",
    });
    const [totalCount, setTotalCount] = React.useState(-1);
    const startIndex = (pageSetting.page - 1) * pageSetting.itemsPerPage;
    const [hitsList, setHitsList] = React.useState([]);


    const toggleLoader = () => {
        noOfApiRan++;
    };

    const getTeamsList = () => {
        const filter = { value: "", status: "" }

        const Options = () => {
            return {
                sort: "",
                page: 0,
                limit: 2,
            };
        };

        let requestLink = `teams/getAll?options=${JSON.stringify(
            Options()
        )}&filter=${JSON.stringify(filter)}`;

        fetchApi({ method: "GET", url: requestLink, isDevApp: false })
            .then((response) => {
                const { docs = [] } = response;
                if (docs.length > 0) {
                    setTeamList([...docs]);
                } else {
                    setTeamList([]);
                }
                toggleLoader();
            })
            .catch(() => {
                setTeamList([]);
                toggleLoader();
            });
    };

    const getCardData = () => {
        fetchApi({ method: "GET", url: "developer/dashboard-data" })
            .then((response) => {
                setCardData(response.docs);
                toggleLoader();
            })
            .catch(() => {
                setCardData({ totalProjects: 0, availableCredits: 0, totalCredits: 0 });
                toggleLoader();
            });
    };

    const onCopy = (apiKey) => {
        navigator.clipboard.writeText(apiKey);
        notification.success({
            message: "Copied to clipboard",
            duration: 3,
        });
    };

    const onExport = () => {
        showLoader(true);
        fetchApi({
            method: "GET",
            url: `projects/${projectId}/exportConfig`,
        })
            .then((response) => {
                const dataStr =
                    "data:text/json;charset=utf-8," +
                    encodeURIComponent(JSON.stringify(response));
                const projectExport = document.getElementById("projectExport");
                projectExport.setAttribute("href", dataStr);
                projectExport.setAttribute("download", `${projectDetails?.name}.json`);
                projectExport.click();
                showLoader(false);
                notification.success({
                    message: "Successfully exported",
                    duration: 3,
                });
            })
            .catch(() => {
                showLoader(false);
                notification.error({
                    message: "Something went wrong. Please try again",
                    duration: 3,
                });
            });
    };

    const onResetApi = () => {
        showLoader(true);
        fetchApi({
            method: "PATCH",
            url: `projects/${projectId}/resetApikey`,
        })
            .then((response) => {
                if (response?.apiKey) {
                    projectDetails.apiKey = response.apiKey;
                    setProjectDetails({ ...projectDetails });
                }
                showLoader(false);
                notification.success({
                    message: "API Key has been successfully reset",
                    duration: 3,
                });
            })
            .catch(() => {
                showLoader(false);
                notification.error({
                    message: "Something went wrong. Please try again",
                    duration: 3,
                });
            });
    };

    const onCreateEndpointRedirect = (record) => {
        navigate(`/endpoints`, { state: { endPointsNav: endPointsNav } });
    }

    const onViewEndpointRedirect = () => {
        navigate(`/endpoints`);
    }

    const onCreateProjectRedirect = (record) => {
        navigate(`/project/create-apps`);
    };

    const onViewProjectRedirect = (record) => {
        navigate(`/project`);
    };

    const onProjectRedirect = (projectID) => {
        navigate(`/project/${projectID}`);
    };

    const getEndpointsList = () => {
        fetchApi({ method: "GET", url: "endpoints" })
            .then((response) => {
                const { docs = [] } = response;
                let list = []
                const data = docs.reverse()
                for (let i = 0; i < data.length; i++) {
                    if (data[i].infraType === "blockchainNode") {
                        if (list.length <= 1) {
                            list.push(data[i])
                        }
                    }
                    setData(list)
                }
            })
            .catch(() => {
                setData([]);
            });
    };

    const getProjectListforcard = () => {
        const Options = () => {
            setHitsList([3, 6, 9, 12]);
            return {
                select: [],
                sort: {},
                page: pageSetting.page - 1,
                limit: pageSetting.itemsPerPage,
            };
        };
        const filter = {};
        const data = {
            "filterType": 'All',
            "filterValue": ""
        }
        fetchApi({
            method: "GET", url: `projects/findAll?options=${JSON.stringify(Options())}&filter=${JSON.stringify(filter)}&searchFilter=${JSON.stringify(data)}`,
            isDevApp: false,
        })
            .then((response) => {
                const { docs = [] } = response;
                let list = []
                for (let i = 0; i < docs.length; i++) {
                    if (list.length <= 1) {
                        list.push(docs[i])
                    }
                }
                setProjectcardData(list)
            })
            .catch((response) => {
                setProjectcardData([]);
            });
    };

    const getActivityList = async () => {
        const Options = () => {
            setHitsList([3, 6, 9, 12]);
            return {
                select: [],
                sort: {},
                page: pageSetting.page - 1,
                limit: pageSetting.itemsPerPage,
            };
        };
        showLoader(true);
        const filter = pageSetting.searchText !== "" ?
            {
                and: [
                    {
                        key: "service",
                        value: pageSetting.searchText,
                        opt: "eq",
                    },
                ],
            } : {
                and: [
                    {
                        key: "subscriptionId",
                        value: subscriptionId,
                        opt: "eq",
                    },
                ],
            };
        try {
            const response = await fetchApi({
                method: "GET",
                url: `developer/dashboard/activity-list?options=${JSON.stringify(Options())}&filter=${JSON.stringify(filter)}`,
                isDevApp: false,
            });
            if (response.statusCode === 200) {
                setActivityList(response.docs);
                showLoader(false);
                setTotalCount(response.meta.totalDocs)
            }
        } catch (error) {
            showLoader(false);
            notification.error({
                message: error.toString(),
                duration: 3,
            });
        }
    };
    const onPageChange = (pageNumber) => {
        pageSetting.page = Number(pageNumber);
        setSetting({ ...pageSetting });
        getActivityList();
    };

    const onPerPageChange = (value) => {
        pageSetting.itemsPerPage = Number(value);
        pageSetting.page = 1;
        setSetting({ ...pageSetting });
        getActivityList();
    };

    const last =
        pageSetting.page * pageSetting.itemsPerPage > totalCount
            ? totalCount
            : pageSetting.page * pageSetting.itemsPerPage;

    return (
        <div className="dashboard-container">
            
            {/*<div className="faq-details marginBtm30">
              {isLoading?(<Skeleton height={48} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
                <Collapse end="right">
                    <Panel header={"Tutorials"} key={"1"} title={"Master your journey with our comprehensive tutorials: From UI essentials to developer docs, unleash the power of our platform and build your first app effortlessly!"}>
                        <div className="card-container grid-repeat-container">
                            <TutorialCard
                                body="Learn how to navigate the dashboard, create new projects, manage tasks, and collaborate with your team."
                                text="GET STARTED WITH KRYPCORE WEB3"
                                color="purple">
                            </TutorialCard>
                            <DeveloperCard
                                body="Calling all developers! Dive into our comprehensive developer documentation to unleash the full potential of Krypcore Web3"
                                text="EXPLORE DEVELOPER RESOURCES"
                                color="purple">
                            </DeveloperCard>
                            <ReleaseCard
                                body="Stay in the loop with our regular updates and new features by checking out our release notes."
                                text="STAY UPTO DATE WITH THE LATEST UPDATES"
                                color="purple">
                            </ReleaseCard>
                            <ExampleCard
                                body="Ready to take your experience with Krypcore Web3 to the next level? Learn how to build your first app using our platform."
                                text="BUILD YOUR OWN APP WITH KRYPCORE WEB3"
                                color="purple">
                            </ExampleCard>
                        </div>
                    </Panel>
                </Collapse>
              )}     
            </div>*/}

            <div className="row">
            <div className="col-md-6">
                <h1 className="header-one">Welcome to Krypcore,</h1>
                <p className="subheader">Feel free to explore, get started when you are ready</p>
                <div>
                    <p className="dashboard-sub-text">{`Subscription ID`} <span className="float-right span-fr">{userData.profile.subscriptionId}<CopyOutlined className="" onClick={() => onCopy(userData.profile.subscriptionId)} /></span></p>
                    <p className="dashboard-sub-text">{`Auth Token`} <span className="float-right span-fr" style={{width: "60%"}}><Input.Password readOnly={true} value={pattoken.patToken !== ""?pattoken.patToken:""} /><CopyOutlined className="" onClick={() => onCopy(pattoken.patToken)} /></span></p>
                </div>
            </div>
            <div className="col-md-6 d-inline-block text-center">
                <div onClick={onCreateEndpointRedirect} className="box-1">
                    <div className="icon-container float-right text-right">
                        <div className="count-container">+</div>
                        <Menus type="" width="37px" height="37px" />
                    </div>
                    <div className="create">Create<br/> Endpoints</div>
                    <span>Setup your Protocol, DID and Storage</span>
                </div>
                <div onClick={onCreateProjectRedirect} className="box-2">
                    <div className="icon-container float-right text-right">
                        <div className="count-container">+</div>
                        <Menus type="" width="37px" height="37px" />
                    </div>
                    <div className="create">Create<br/> dApps</div>
                    <span>Configure your decentralised application</span>
                </div>
            </div>
            </div>


            <div className="container-text" style={{marginTop:"3.5rem",opacity:0.8}}><div className="text">Metrics Overview</div></div>
            <div className="card-container grid-repeat-container marginBtm50 mt-lg-3">
                {isLoading?(<Skeleton height={124} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
                <Card
                    type="ds-teams"
                    count={cardData?.totalProjects}
                    text="Number of Dapps"
                    color="purple"
                />
                )} 

                {isLoading?(<Skeleton height={124} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
                <Card
                    type="active"
                    count={cardData?.availableCredits}
                    text="Credits Used"
                    color="orange"
                />
                )}

                {isLoading?(<Skeleton height={124} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
                <Card
                    type="credit"
                    count={cardData?.totalCredits}
                    text="Credits Left"
                    color="green"
                />  
                )}
        
                {isLoading?(<Skeleton height={124} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
                <Card
                    type="request"
                    count={cardData?.totalRequests}
                    text="Api Hits"
                    color="blue"
                />   
                )}    
            </div>
            {/*<div style={{ display: "flex", columnGap: "20px" }} className="marginBtm50">
                <div style={{ width: "50%" }}>
                    {userRole === ENTERPRISEDEVELOPERROLE ? <></> :
                        <>
                          <div className="container-text marginBtm15"><div className="text">Endpoints</div></div>
                            {isLoading?(<Skeleton height={110} style={{marginBottom:'50px'}} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
                                <div className="box-parent marginBtm50">
                                  {data.length === 0 ?
                                    <button className="gradient-button button-glowing" onClick={onCreateEndpointRedirect}>
                                        Create New
                                    </button>
                                    : <><button className="gradient-button" onClick={onCreateEndpointRedirect}>
                                        Create New
                                    </button>
                                    {data.map((item) => (
                                        <EndpointCard3
                                            type="request"
                                            name={item.protocolName !== undefined ? item.protocolName.split('-')[0] : ""}
                                            body={item.network !== undefined ? item.network : ""}
                                            text="Endpoints"
                                            color="blue"
                                        />
                                    ))}
                                    <>
                                    <a className="gradient-a" onClick={onViewEndpointRedirect}>
                                        View All
                                    </a></>
                                    </>}
                                </div>
                            )} 
                        </>
                    }
                    <div className="container-text marginBtm15"><div className="text">dApps</div></div>
                      {isLoading?(<Skeleton height={110}  baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
                        <div className="box-parent radial-gradient-purple">
                          {projectcarddata.length === 0 ?
                            (userRole === ENTERPRISEDEVELOPERROLE && teamList.length === 0 ? <></> :
                                    <button className="gradient-button button-glowing" onClick={onCreateProjectRedirect}>
                                        Create New
                            </button>)
                            : <>
                                <button className="gradient-button" onClick={onCreateProjectRedirect}>
                                    Create New
                                </button>
                                {projectcarddata.map((item) => (
                                    <ProjectCard
                                        type="request"
                                        name={item.projectName !== undefined ? item.projectName : ""}
                                        text="Endpoints"
                                        color="blue"
                                        onClick={() => onProjectRedirect(item.projectID)}
                                    />
                                ))}
                                <><a className="gradient-a" onClick={onViewProjectRedirect}>
                                    View All
                                </a></>
                            </>}
                        </div>
                      )}
               
                </div>
                <div style={{ width: "50%" }}>
                    <AccountInfoInfo
                        text="Account Information"
                        item={projectDetails}
                        isLoading={isLoading}
                        onCopy={onCopy}
                        onResetApi={onResetApi}
                        onExport={onExport}
                    />
                </div>
            </div>*/}
            {isLoading?(<Skeleton height={200} baseColor="#262626" highlightColor="#404040" ></Skeleton>):( 
                <TableContent
                    pagination={false}
                    text="Recent API requests"
                    tooltip="This is a tabular summary of the information like method used ,API Call Time, API Credits Exhausted etc while writing the code."
                    rowKey="id"
                    columns={activityColumns}
                    data={activityList}
                />
            )}
          
            <PaginationSection
                last={last}
                first={startIndex + 1}
                hitsList={hitsList}
                totalCount={totalCount}
                page={pageSetting.page}
                itemsPerPage={pageSetting.itemsPerPage}
                onPageChange={onPageChange}
                onPerPageChange={onPerPageChange}
            />
        </div>
    );
};

export default Dashboard;